import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { Component, Fragment, useState } from 'react';
import { debounce } from 'underscore';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UITextInput from 'UIComponents/input/UITextInput';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import H2 from 'UIComponents/elements/headings/H2';
import Small from 'UIComponents/elements/Small';
import Routes from 'ContentUtils/Routes';
import * as workflowsSelectors from 'ContentData/selectors/workflows';
import * as WorkflowsActions from 'ContentData/actions/Workflows';
import * as FormsActions from 'ContentData/actions/Forms';
import { ACCEPTED_SOURCE_APPS } from 'ContentData/constants/workflows';
import AsyncSelector from 'ContentComponents/cmv2/components/AsyncSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function mapStateToProps(state, props) {
  const {
    formGuid,
    contentId
  } = props;
  return {
    workflowSummariesOptions: workflowsSelectors.getWorkflowSummariesOptions(state, {
      formGuid,
      contentId
    })
  };
}
const mapDispatchToProps = {
  addFormAsWorkflowEnrollmentCriteria: FormsActions.addFormAsWorkflowEnrollmentCriteria,
  fetchWorkflowSummaries: WorkflowsActions.fetchWorkflowSummaries,
  clearWorkflowSummaries: WorkflowsActions.clearWorkflowSummaries,
  createWorkflowAndFormAsEnrollmentCriteria: FormsActions.createWorkflowAndFormAsEnrollmentCriteria
};
const connector = connect(mapStateToProps, mapDispatchToProps);
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.workflowSelect.${key}`;
const PAGE_SIZE = 50;
const CreateNewWorkflowModal = ({
  isCreating,
  onClose,
  onWorkflowCreate
}) => {
  const [name, setName] = useState('');
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('createNewWorkflowModal.header')
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('createNewWorkflowModal.nameLabel')
        }),
        children: /*#__PURE__*/_jsx(UITextInput, {
          value: name,
          onChange: e => setName(e.target.value)
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsxs(UILoadingButton, {
        disabled: !name,
        loading: isCreating,
        onClick: () => onWorkflowCreate(name),
        use: "primary",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('createNewWorkflowModal.create')
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "externalLink"
        })]
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('createNewWorkflowModal.cancel')
        })
      })]
    })]
  });
};
class WorkflowSelect extends Component {
  constructor(props) {
    super(props);
    this.closeCreateModal = this.closeCreateModal.bind(this);
    this.setIsAdding = this.setIsAdding.bind(this);
    this.onWorkflowCreate = this.onWorkflowCreate.bind(this);
    this.onWorkflowSelect = this.onWorkflowSelect.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
    this.debouncedLoadOptions = debounce(this.loadOptions, 300);
    this.renderOption = this.renderOption.bind(this);
    this.state = {
      input: '',
      isAdding: false,
      isCreateModalOpen: false,
      isCreating: false
    };
  }
  closeCreateModal() {
    this.setState({
      isCreateModalOpen: false
    });
  }
  setIsAdding(isAdding) {
    const {
      hasNoWorkflows,
      onAddFirstWorkflow
    } = this.props;
    if (hasNoWorkflows) {
      onAddFirstWorkflow(isAdding);
    } else {
      this.setState({
        isAdding
      });
    }
  }
  onWorkflowCreate(name) {
    const {
      onAddWorkflowEvent,
      contentId,
      createWorkflowAndFormAsEnrollmentCriteria,
      formGuid
    } = this.props;
    this.setState({
      isCreating: true
    });
    if (onAddWorkflowEvent) onAddWorkflowEvent({
      created_new_workflow: true
    });
    createWorkflowAndFormAsEnrollmentCriteria(name, formGuid, contentId).then(response => {
      this.setState({
        isCreating: false
      });
      if (response && response.flowId) {
        window.open(Routes.workflows(response.flowId, 'AUTOMATION_PLATFORM'));
      } else {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('createNewWorkflowModal.createError')
          }),
          type: 'danger'
        });
      }
      this.closeCreateModal();
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  onWorkflowSelect(option) {
    const {
      addFormAsWorkflowEnrollmentCriteria,
      contentId,
      formGuid,
      onAddWorkflowEvent
    } = this.props;
    const flowId = option.value;
    this.setIsAdding(true);
    if (onAddWorkflowEvent) onAddWorkflowEvent();
    addFormAsWorkflowEnrollmentCriteria(flowId, formGuid, contentId).then(response => {
      this.setIsAdding(false);
      if (!(response && response.flowId)) {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('addError'),
            options: {
              workflowName: option.text
            }
          }),
          type: 'danger'
        });
      }
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  loadOptions(input, callback, pagination) {
    const {
      clearWorkflowSummaries,
      fetchWorkflowSummaries
    } = this.props;
    let {
      offset = 0
    } = pagination || {};
    if (input !== this.state.input) {
      this.setState({
        input
      });
      clearWorkflowSummaries();
      offset = 0;
    }
    const query = {
      offset,
      name: input,
      limit: PAGE_SIZE,
      sortBy: 'createdAt',
      platformSourceApps: [ACCEPTED_SOURCE_APPS.WORKFLOWS_CLASSIC, ACCEPTED_SOURCE_APPS.WORKFLOWS_APP, ACCEPTED_SOURCE_APPS.FORM_FIELD_FOLLOWUP, ACCEPTED_SOURCE_APPS.CMS_FORM_MODULE_FIELD]
    };
    fetchWorkflowSummaries(query).then(response => {
      const {
        workflowSummariesOptions: options
      } = this.props;
      const {
        total
      } = response;
      callback(null, {
        options,
        pagination: {
          hasMore: total > options.length,
          offset: offset + PAGE_SIZE,
          length: total
        }
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  renderOption(_ref) {
    let {
        children,
        option
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(UITooltip, {
        placement: "right",
        title: option.shouldEditManually ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('disabledTooltip.shouldEditManually')
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('disabledTooltip.default')
        }),
        disabled: !option.disabled,
        children: children
      })
    }));
  }
  render() {
    const {
      isAdding,
      isCreateModalOpen,
      isCreating
    } = this.state;
    const {
      clearWorkflowSummaries,
      hasNoWorkflows,
      hasWorkflowsAppAccess
    } = this.props;
    if (isAdding) return /*#__PURE__*/_jsx(UILoadingSpinner, {
      className: "m-y-3",
      grow: true
    });
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [isCreateModalOpen && /*#__PURE__*/_jsx(CreateNewWorkflowModal, {
        isCreating: isCreating,
        onClose: this.closeCreateModal,
        onWorkflowCreate: this.onWorkflowCreate
      }), /*#__PURE__*/_jsx(AsyncSelector, {
        buttonUse: hasNoWorkflows ? 'tertiary-light' : 'link',
        buttonSize: "sm",
        clearCache: clearWorkflowSummaries,
        dropdownFooter: hasWorkflowsAppAccess && /*#__PURE__*/_jsx(UIButton, {
          onClick: () => this.setState({
            isCreateModalOpen: true
          }),
          use: "link",
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('createNewWorkflow')
            })
          })
        }),
        itemComponent: this.renderOption,
        loadOptions: this.debouncedLoadOptions,
        menuWidth: 250,
        options: this.props.workflowSummariesOptions,
        onChange: () => {}
        // onSelectedOptionChange gives us access to the whole option
        ,
        onSelectedOptionChange: e => this.onWorkflowSelect(e.target.value)
        // saveCache is required for AsyncSelector but can be empty
        // since we don't actually display the selected workflow
        ,
        saveCache: () => {}
        // Don't actually select a workflow when you click on it
        ,
        value: null,
        valueRenderer: () => hasNoWorkflows ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('addFormToWorkflow')
        }) : /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('addFormToAnotherWorkflow')
          })
        })
      })]
    });
  }
}
export default connector(WorkflowSelect);